<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "CallHistoryExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/viber', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            client: item.client.domain,
            fromUser: item.user && item.user.name ? item.user.name : '',
            brandName: item.brandName ? item.brandName.name : '',
            number: item.number,
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss'),
            content: item.content,
            sendError: item.sendError,
            sendErrorMsg: item.sendErrorMsg,
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'sms-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('client'), key: 'client', width: 15},
        {header: this.$t('fromUser'), key: 'fromUser', width: 15},
        {header: this.$t('brandName'), key: 'brandName', width: 15},
        {header: this.$t('number'), key: 'number', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('sendTime'), key: 'sendTime', width: 15},
        {header: this.$t('content'), key: 'content', width: 50},
        {header: this.$t('sendError'), key: 'sendError', width: 15},
        {header: this.$t('sendErrorMsg'), key: 'sendErrorMsg', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },

}
</script>